import LocatorHours from './LocatorHours';
import CarIcon from '@/icons/CarIcon';
import CloseIcon from '@/icons/CloseIcon';
import { type Station } from './Locator.types';

type LocatorResultProps = {
  station: Station;
  currentDuration?: string;
  isCurrentStation?: boolean;
  onClose?: () => void;
};

const LocatorResult: React.FC<LocatorResultProps> = ({
  station,
  currentDuration,
  isCurrentStation = false,
  onClose,
}) => {
  if (!station) {
    return null;
  }

  const {
    site_id,
    link,
    name,
    location,
    pay_at_pump_247: isPayAtPump247,
    opening_hours: openingHours,
    services,
  } = station;
  const classNames = ['locator-result'];

  if (isCurrentStation) {
    classNames.push('locator-result--current');
  }

  const { address } = location;

  return (
    <li className={classNames.join(' ')} key={`station-${site_id}`}>
      {isCurrentStation && onClose && (
        <button className="locator-result__close-button" onClick={onClose}>
          <CloseIcon fill="#1E196A" size={16} />
        </button>
      )}

      <h2 className="locator-result__heading h4">
        <a href={link}>{name}</a>
      </h2>

      <p className="locator-result__address h5">{address}</p>

      {isCurrentStation && currentDuration && (
        <p className="locator-result__duration">
          <CarIcon />
          {currentDuration}
        </p>
      )}

      <LocatorHours
        isPayAtPump247={isPayAtPump247}
        openingHours={openingHours}
      />

      {services.length > 0 && (
        <ul className="locator-result__services">
          {services.map((service) => (
            <li className="locator-result__service" key={service.name}>
              {service.name}
            </li>
          ))}
        </ul>
      )}
    </li>
  );
};

export default LocatorResult;
